module.exports = __webpack_public_path__ + "img/tag.916e4241.svg";